import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab';
import { createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { LIGHT_RED_BOX, RED_COLOR } from '../../const/color-const';

const styles = createStyles((theme) => ({
  snackbarWrapper: {
    border: theme.palette.type === 'light' ? `1px solid ${LIGHT_RED_BOX}` : `1px solid ${RED_COLOR}`,
    borderRadius: 4,
    '& div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      height: 60,
    },
  },
}));

const AppMessageBar = (props) => {
  const { status, classes } = props;
  const [snackbarStatus, setSnackbarStatus] = React.useState(null);
  
  React.useEffect(() => {
    if (status && status.message) {
      setSnackbarStatus(status);
    }
  }, [status]);
  
  return (
    <Snackbar className={classes.snackbarWrapper}
              open={!!snackbarStatus}
              autoHideDuration={10000}
              onClose={() => setSnackbarStatus(null)}>
      <Alert severity="error">
        {snackbarStatus && snackbarStatus.message}
      </Alert>
    </Snackbar>
  );
};

export default withStyles(styles)(AppMessageBar);